import React from "react";
import { Accordion, Box } from "@chakra-ui/react";
import type { IContentHeader } from "../../..";
import MenuItem from "../MenuItem";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../../../../hooks";
import addAnalyticSanitize from "../../../../../hooks/useAnalytics/functions/addAnalyticSanitize";

interface IMenuListProps {
	isOpen: boolean;
	contents: IContentHeader[];
  setIsOpen?: (isOpen: boolean) => void;
}

const MenuList: React.FC<IMenuListProps> = observer(({ isOpen, contents, setIsOpen }) => {
	const { addAnalyticEvent, updatePageView } = useAnalytics();
	const handleTriggerTagging = (description: string, step?: string): void => {
		updatePageView({
			name: `Vivo Money Menu ${description === "Outros serviços" ? "Outros Servicos" : "Emprestimos"}`,
			pagePath: "/menu",
		});

		addAnalyticEvent({
			component: "body",
			action: "click.button",
			step: step ? `fgts:menu:${addAnalyticSanitize(step)}` : "fgts:menu",
			description,
			value: "",
		},
		{applySanitize: true});
	};

	return (
		<Box
			width={"100%"}
			bg={"white"}
			position={"absolute"}
			top={isOpen ? "56px" : 0}
			right={0}
			zIndex={998}
			transition={"top .2s ease-in 0s"}
		>
			{isOpen && (
				<>
					<Accordion allowToggle>
						{contents.map(({ menu, subMenu }, index) => (
							<MenuItem key={index} menu={menu} subMenu={subMenu} setIsOpen={setIsOpen} onTriggerTagging={handleTriggerTagging} />
						))}
					</Accordion>
				</>
			)}
		</Box>
	);
});

export default MenuList;
